import { createRoot } from "react-dom/client";
import { ThemeProvider } from "next-themes";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import { initWebVitals } from "@/lib/perf";
import "mapbox-gl/dist/mapbox-gl.css";
import "./index.css";

initWebVitals();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <App />
    </ThemeProvider>
  </HelmetProvider>
);

